/* eslint-disable promise/prefer-await-to-then */
import { createAction, type Dispatch } from '@reduxjs/toolkit';

import * as types from 'src/core/actionTypes/groups';
import { companyAPI } from 'src/core/api/axios';
import { apiUrl } from 'src/core/utils/api';

import { type AppState } from '../reducers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Params = Record<string, any>;
const fetchGroupsLoading = createAction(types.FETCH_GROUPS_LOADING);
const fetchGroupsFailure = createAction(types.FETCH_GROUPS_FAILURE);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetchGroupsSuccess = createAction<{ groups: any[] }>(
  types.FETCH_GROUPS_SUCCESS,
);
export const fetchGroups =
  (params: Params = {}) =>
  async (dispatch: Dispatch, getState: () => AppState) => {
    dispatch(fetchGroupsLoading());
    const { piGroups } = params;
    const endpoint = piGroups ? '/all-company-groups' : '/groups';
    const companyId = getState().global.company?.id ?? '';

    let groups;
    try {
      const res = await companyAPI.get(endpoint, { companyId });

      groups = res.data;
    } catch (error) {
      dispatch(fetchGroupsFailure());
      throw error;
    }

    if (!Array.isArray(groups)) {
      return dispatch(fetchGroupsFailure());
    }
    dispatch(fetchGroupsSuccess({ groups }));
  };

const groupAddUsersLoading = createAction(types.GROUP_ADD_USERS_LOADING);
const groupAddUsersFailure = createAction(types.GROUP_ADD_USERS_FAILURE);
const groupAddUsersSuccess = createAction(types.GROUP_ADD_USERS_SUCCESS);
export const addUsersToGroup =
  (
    { user_ids, group_id }: { user_ids: string[]; group_id: string },
    callback = () => {},
  ) =>
  (dispatch: Dispatch, getState: () => AppState) => {
    // FIXME API : can only add/remove users one by one
    const companyId = getState().global.company?.id;

    dispatch(groupAddUsersLoading());

    const posts = (user_ids ?? []).map((user_id) =>
      fetch(apiUrl(`/groups/${group_id}/users`, companyId), {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id }),
      }).then((res) =>
        res.status === 200 ? res.json() : Promise.resolve(null),
      ),
    );

    return Promise.all(posts)
      .then(() => fetchGroups()(dispatch, getState)) // refresh groups globally
      .then(() => dispatch(groupAddUsersSuccess()))
      .then(callback)
      .catch(() => dispatch(groupAddUsersFailure()));
  };

const groupRemoveUsersLoading = createAction(types.GROUP_REMOVE_USERS_LOADING);
const groupRemoveUsersFailure = createAction(types.GROUP_REMOVE_USERS_FAILURE);
const groupRemoveUsersSuccess = createAction(types.GROUP_REMOVE_USERS_SUCCESS);
export const removeUsersFromGroup =
  (
    { user_ids, group_id }: { user_ids: string[]; group_id: string },
    callback = () => {},
  ) =>
  (dispatch: Dispatch, getState: () => AppState) => {
    const companyId = getState().global.company?.id;

    dispatch(groupRemoveUsersLoading());

    const deletes = (user_ids ?? []).map((user_id) =>
      fetch(apiUrl(`/groups/${group_id}/users/${user_id}`, companyId), {
        method: 'DELETE',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id }),
      }).then((res) =>
        res.status === 200 ? res.json() : Promise.resolve(null),
      ),
    );

    return Promise.all(deletes)
      .then(() => fetchGroups()(dispatch, getState)) // refresh groups globally
      .then(() => dispatch(groupRemoveUsersSuccess()))
      .then(callback)
      .catch(() => dispatch(groupRemoveUsersFailure()));
  };
